/**
 * EmptyState — Consistent empty/no-data UI
 */
import { Box, Button, Typography } from '@mui/material';
import React from 'react';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: { label: string; onClick: () => void; startIcon?: React.ReactNode };
}

const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description, action }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      py: { xs: 6, md: 10 },
      px: 3,
      textAlign: 'center',
    }}
  >
    {icon && (
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          bgcolor: 'rgba(79,70,229,0.08)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 2.5,
          '& svg': { fontSize: 28, color: '#4f46e5', opacity: 0.7 },
        }}
      >
        {icon}
      </Box>
    )}
    <Typography
      variant="h6"
      sx={{ color: 'text.primary', fontWeight: 600, mb: description ? 1 : 0 }}
    >
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 360 }}>
        {description}
      </Typography>
    )}
    {action && (
      <Button
        variant="contained"
        size="small"
        startIcon={action.startIcon}
        onClick={action.onClick}
        sx={{ mt: 3 }}
      >
        {action.label}
      </Button>
    )}
  </Box>
);

export default EmptyState;
